import { useEffect, useState } from 'react';

import { RACAffordabilityEngine } from './RACAffordabilityEngine';

export const RACAffordabilityEngineController: React.FC = () => {
  const [isRACDisplayed, setIsRACDisplayed] = useState(false);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      setIsRACDisplayed(true);
    });

    return () => cancelAnimationFrame(frameId);
  }, []);

  return isRACDisplayed ? <RACAffordabilityEngine /> : null;
};
